export default __webpack_public_path__ + "static/media/book.82f330bd.svg";